import { Injectable, signal, inject } from '@angular/core';
import {
  SubscriptionFrequency,
  SubscriptionPayload,
  SubscriptionProRata,
} from '../../_interfaces/subscription.interface';
import { ModalComponent } from '../../shared/components/modals/modal/modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../toast-service/toast.service';
import { OffcanvasService } from '../offcanvas-service/offcanvas.service';
import { SubscriptionApiService } from './api/subscription-api-service.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  readonly modalService = inject(NgbModal);
  readonly toastService = inject(ToastService);
  readonly subscriptionApiService = inject(SubscriptionApiService);
  readonly offcanvasService = inject(OffcanvasService);

  readonly currentSubscriptionCardsMax = signal<number | undefined>(undefined);

  constructor() {
    this.getSubscriptionCardsMax();
  }

  getSubscriptionCardsMax() {
    this.subscriptionApiService.getCurrentSubscription().subscribe({
      next: (res) => {
        this.currentSubscriptionCardsMax.set(res.package.cards_max);
      },
    });
  }

  onUpgradePackage(data: SubscriptionPayload, packageName: string) {
    const modalRef = this.modalService.open(ModalComponent, {
      centered: true,
      size: 'md',
    });
    modalRef.componentInstance.title = 'Confirm Upgrade';
    modalRef.componentInstance.bodyText = 'Are you sure you want to upgrade your plan?';
    modalRef.componentInstance.buttonTextAction = 'Confirm';
    modalRef.componentInstance.buttonTextDismiss = 'Cancel';
    modalRef.closed.subscribe({
      next: () => {
        this.subscriptionApiService.selectSubscriptionUpgradePackage(data).subscribe({
          next: () => {
            this.offcanvasService.close('/your-plan');
            this.toastService.show(`Subscription plan has been updated to ${packageName}`, 'iconoir-check-circle');
          },
          error: () => {
            this.toastService.show('Failed to upgrade your plan. Please try again later.', 'iconoir-xmark');
          },
        });
      },
    });
  }

  calculateSavings(baseCost: number, yearlyCost: number) {
    return baseCost - yearlyCost;
  }

  getProRataAmount(packageId: number, frequency: SubscriptionFrequency): Observable<SubscriptionProRata> {
    return this.subscriptionApiService.getSubscriptionProRata(packageId, frequency);
  }
}
